import { Button } from '@fluentui/react-components';
import { SearchBox } from "@fluentui/react"
import { IButtonsGroupTabla } from "../../Interfaces/filter";
import { ComboBoxComponent } from "../comboBox/ComboBoxComponent";
import { ChangeEvent } from 'react';

export const ButtonsGroupTabla = (props: IButtonsGroupTabla) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "end",
        borderBottom: "0.5px solid #b3b3b3",
        boxShadow: "0px 1px 0px rgba(0, 0, 0, 0.1)",
      }}
    >
      <div key={"leftBotton"}>
        <div style={{ display: "flex" }}>
          {props.leftButtons?.map((button, index) => (
            <Button
              key={index}
              onClick={button.onClick}
              style={{ fontSize: "12px", fontWeight: "normal" }}
              appearance={button.type == undefined ? "subtle" : button.type}
              icon={button.icon}
            >
              {button.text}
            </Button>
          ))}
        </div>
      </div>
      <div key={"rightBotton"}>
        <div
          style={{
            display: "flex",
            gap: "4px",
            justifyContent: "center",
            alignItems: "end"
          }}
        >
          {props.comboOptions ? (
            <ComboBoxComponent
              text=""
              defaultSelectedOptions={props.defaultSelectedOptions ?? []}
              data={props.comboOptions}
              onOptionSelect={props.onSelectCombo}
            />
          ) : (
            true
          )}
          {props.isSearch && (
            <SearchBox
              type={"search"}
              value={props?.value}
              styles={{
                root: {
                  border: "1px solid #d6d6d6",
                  borderRadius: "5px",
                  marginTop: "5px",
                  height: "28px", 
                },
                field: {
                  padding: "3px 5px", 
                  fontSize: "12px", 
                },
              }}
              placeholder={props.placeholder ?? ""}
              onChange={(event, data) => {
                if (props.onChangeSearch && event && data !== undefined) {
                  const adaptedEvent = event as ChangeEvent<HTMLInputElement>;
                  props.onChangeSearch(adaptedEvent, data);
                }
              }}
            />
          )}
          {props.rightButton?.map((button, index) => (
            <Button
              key={index}
              onClick={button.onClick}
              style={{ fontSize: "12px", fontWeight: "normal" }}
              appearance={button.type == undefined ? "subtle" : button.type}
              icon={button.icon}
            >
              {button.text}
            </Button>
          ))}
          {props.rightText ? <span>{props.rightText}</span> : true}

        </div>
      </div>
    </div>
  )
}